import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultCorporateLifeSeriesContent } from '../../siteContent';
import { useCms, Text } from './cmsShared';

const AdminContentCorporateLifeSeries = () => {
  const { content, update, save, saving } = useCms('corporatelifeseries', defaultCorporateLifeSeriesContent);
  const c = content;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="font-heading text-xl font-bold text-[#003366]">Corporate Life Series — Content</h2>
          <p className="text-sm text-gray-500">Edit hero text, each session's month and topic, and the closing section.</p>
        </div>
        <Button onClick={save} disabled={saving} data-testid="cms-cls-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>

      <Accordion type="multiple" defaultValue={['hero', 'series']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Hero Section</AccordionTrigger>
          <AccordionContent>
            <Text label="Badge label" value={c.hero.badge} onChange={(v) => update(['hero', 'badge'], v)} />
            <div className="grid grid-cols-2 gap-3">
              <Text label="Title prefix (e.g. 'The ')" value={c.hero.titlePre} onChange={(v) => update(['hero', 'titlePre'], v)} />
              <Text label="Title highlight (shown in red)" value={c.hero.titleHighlight} onChange={(v) => update(['hero', 'titleHighlight'], v)} />
            </div>
            <Text label="Subtitle / description" value={c.hero.subtitle} onChange={(v) => update(['hero', 'subtitle'], v)} area />
            <Text label="CTA button label" value={c.hero.cta} onChange={(v) => update(['hero', 'cta'], v)} />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="series" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Session Schedule ({(c.series || []).length} sessions)</AccordionTrigger>
          <AccordionContent>
            <p className="text-xs text-gray-400 mb-3">Icons are fixed by session order. Edit the month label and topic for each row.</p>
            {(c.series || []).map((s, i) => (
              <div key={i} className="border rounded-lg p-3 mb-3 bg-gray-50 grid grid-cols-2 gap-3">
                <Text label={`Session ${i + 1} — Month`} value={s.month} onChange={(v) => update(['series', i, 'month'], v)} />
                <Text label="Topic" value={s.topic} onChange={(v) => update(['series', i, 'topic'], v)} />
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="closing" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Closing Section</AccordionTrigger>
          <AccordionContent>
            <Text label="Heading" value={c.closing.heading} onChange={(v) => update(['closing', 'heading'], v)} area />
            <Text label="Subtext" value={c.closing.subtext} onChange={(v) => update(['closing', 'subtext'], v)} area />
            <Text label="CTA button" value={c.closing.cta} onChange={(v) => update(['closing', 'cta'], v)} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="flex justify-end mt-6">
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}
        </Button>
      </div>
    </div>
  );
};

export default AdminContentCorporateLifeSeries;
